import React from 'react';

import { ButtonToolbar, Table } from 'components/bootstrap';
import { Timestamp } from 'components/common';
import DataWarehouseDetailsPageSubactions from 'data-warehouse/components/DataWarehouseDetailsPageSubactions';
import DaysOfData from 'data-warehouse/data-warehouse-overview/cells/DaysOfData';
import type { DataWarehouse } from 'data-warehouse/Types';

type Props = {
  dataWarehouse: DataWarehouse,
}

const DataWarehouseSummary = ({ dataWarehouse }: Props) => (
  <Table>
    <thead>
      <tr>
        <th>Message Count</th>
        <th>Days of Data</th>
        <th>From</th>
        <th>To</th>
        <th className="text-right">Actions</th>
      </tr>
    </thead>
    <tbody>
      <tr>
        <td>{dataWarehouse.message_count}</td>
        <td><DaysOfData datawarehouse={dataWarehouse} /></td>
        {/* eslint-disable-next-line jsx-a11y/control-has-associated-label */}
        <td><Timestamp dateTime={dataWarehouse.timestamp_from} /></td>
        {/* eslint-disable-next-line jsx-a11y/control-has-associated-label */}
        <td><Timestamp dateTime={dataWarehouse.timestamp_to} /></td>
        {/* eslint-disable-next-line jsx-a11y/control-has-associated-label */}
        <td>
          <ButtonToolbar className="pull-right">
            <DataWarehouseDetailsPageSubactions dataWarehouse={dataWarehouse} />
          </ButtonToolbar>
        </td>
      </tr>
    </tbody>
  </Table>
);

export default DataWarehouseSummary;
